import React from "react";

const ICONS = {
  info: "ℹ",
  success: "✓",
  warning: "⚠",
  danger: "✕",
};

/**
 * Aviso inline dentro de una página o formulario (no flotante como el toast).
 * Props:
 *  - variant: "info" | "success" | "warning" | "danger"
 *  - title: título en negrita opcional
 *  - onClose: si se pasa, muestra botón de cierre
 */
function Alert({ variant = "info", title, onClose, className = "", children, ...rest }) {
  return (
    <div
      role="alert"
      className={`sw-ui-alert sw-ui-alert--${variant} ${className}`}
      {...rest}
    >
      <span className="sw-ui-alert-icon" aria-hidden="true">
        {ICONS[variant] || ICONS.info}
      </span>
      <div className="sw-ui-alert-content">
        {title && <p className="sw-ui-alert-title">{title}</p>}
        <div className="sw-ui-alert-body">{children}</div>
      </div>
      {onClose && (
        <button
          type="button"
          className="sw-ui-alert-close"
          onClick={onClose}
          aria-label="Cerrar"
        >
          ×
        </button>
      )}
    </div>
  );
}

export default Alert;
